import ztComponent from './ztBadge.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
